import { getDatabase, ref, update } from 'firebase/database';

export const toggleDisableSecondaryCameraInFirebase = (sessionId: string, isSecondaryDisabled: boolean) => {
    const database = getDatabase();
    const streamingRef = ref(database, `session/${sessionId}/streaming_device`);
    update(streamingRef, { is_secondary_disabled: isSecondaryDisabled });
};
